import parser from 'bbcode-to-react'

export interface BBCodeProps {
  children: string
}

export default function BBCode(props: BBCodeProps) {
  return parser.toReact(props.children)
}
